export const demoCompare = {
  xfactor: "?",
  ball_handling: "TBD",
  scoring: "TBD",
  rebounding: "TBD",
  defense: "TBD",
  playmaking: "TBD",
};
